module.exports = __webpack_public_path__ + "img/4cfd6d29919e4d1faa0fcadf1c3c8e12.996dafe3.png";